import SubjectDetailBookBlock from "./SubjectDetailBookBlock";
import SubjectSideBar from "./SubjectSidebar";

const SubjectContent = ({ data, url, type, title, crumb }) => {
  return (
    <div className="container-fluid refine_section">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="container refine_padding">
            <div className="row">
              {data.sidebar && (
                <SubjectSideBar
                  data={data.sidebar}
                  title={title}
                  type={type}
                  current={data?.subject_header?.subject_name}
                />
              )}
              {(data.subject_book || data.series_books) && (
                <SubjectDetailBookBlock
                  subjectBooks={type ? data.series_books : data.subject_book}
                  limit={data.last_limit}
                  totalCount={type ? data.total_count : data.count}
                  url={url}
                  crumb={crumb}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectContent;
